import { useQuoteStore } from '@/stores/quote';

export default defineNuxtRouteMiddleware((to, from) => {
  const quoteStore = useQuoteStore();
  if (!quoteStore.isQuoteEditMode) return;

  const { setQuoteEditMode, setQuoteContext: setContextInStore } = quoteStore;

  const newContext = setQuoteContext(from?.path || '', to.path, quoteStore.quoteContext);

  if (newContext !== quoteStore.quoteContext) {
    if (newContext === 'normal') {
      setQuoteEditMode(false);
      setContextInStore(newContext);
    } else setContextInStore(newContext);
  }
});
